<div *ngIf="detailsData.loading" class="empty-state" [style.height.px]="height" [dataCy]="'table-loading-state'">
  <app-dot-loader *ngIf="detailsData.loading"></app-dot-loader>
  <p>{{ 'data-download-in-progress' | translate }}</p>
</div>
